import React, { useEffect, useState } from "react";
import { all_routes } from "../router/all_routes";
import Select from "react-select";
import * as api from "../constant/API";
import Utils from "../constant/Utils";
import Swal from "sweetalert2";
import { Link } from "react-router-dom";
import { Button } from "react-bootstrap";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import * as XLSX from "xlsx";

const bmiReport = () => {

    const routes = all_routes;
    const roleId = localStorage.getItem('RoleId');

    const [searchInput, setSearchInput] = useState('');
    const [groupList, setGroupList] = useState([]);
    const [instituteList, setInstituteList] = useState([]);
    const [batchList, setBatchList] = useState([]);
    const [bmiRptList, setBmiRptList] = useState([]);
    const [groupId, setGroupId] = useState('');
    const [institutionId, setInstitutionId] = useState('');
    const [batchId, setBatchId] = useState('All');
    const [showTable, setShowTable] = useState(false);

    useEffect(() => {
        getGroupList()
    }, [])

    function getGroupList() {
        const grpLst = api.InstituteTypeList + '/' + roleId;
        fetch(grpLst, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "Authorization": 'Bearer ' + Utils.getAccessToken()
            }
        })
            .then((grpResponse) => grpResponse.json())
            .then((grpResult) => {
                if (grpResult.error == false) {
                    setGroupList(grpResult.data)
                }
                else {
                    Swal.fire(grpResult.message)
                    if (grpResult.code == 401) {
                        Utils.logoutUser();
                    }
                }
            })
    }

    function getInstitutes(grpId) {
        const institute = api.GetReportInstitutions + '/' + roleId + '/' + grpId;
        fetch(institute, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "Authorization": 'Bearer ' + Utils.getAccessToken()
            }
        })
            .then((instReponse) => instReponse.json())
            .then((instResult) => {
                if (instResult.error == false) {
                    setInstituteList(instResult.data)
                }
                else {
                    Swal.fire(instResult.message)
                    if (instResult.code == 401) {
                        Utils.logoutUser();
                    }
                }
            })
            .catch((error) => {
                console.log("Failed to fetch institution list", error)
            })
    }

    function getBatchList(insid) {
        const getbtchlst = api.GetBMIBatches + '/' + insid //"?InstId=" + insid;
        fetch(getbtchlst, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "Authorization": 'Bearer ' + Utils.getAccessToken()
            }
        })
            .then((btchResponse) => btchResponse.json())
            .then((btchResult) => {
                if (btchResult.error == true) {
                    if (btchResult.code == 401) {
                        Utils.logoutUser();
                    }
                } else {
                    if (btchResult.data != null) {
                        setBatchList(btchResult.data)
                    }
                }
            })
            .catch((error) => {
                console.log("Failed to fetch batch list.", error)
            })
    }

    function getReport() {
        const getBmiReport = api.GetBMIReport + '/' + institutionId + '/' + groupId + '/' + batchId;
        fetch(getBmiReport, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "Authorization": 'Bearer ' + Utils.getAccessToken()
            }
        })
            .then((bmiResponse) => bmiResponse.json())
            .then((bmiResult) => {
                if (bmiResult.error == true) {
                    if (bmiResult.code == 401) {
                        Utils.logoutUser();
                    }
                } else {
                    if (bmiResult.data != null) {
                        setBmiRptList(bmiResult.data)
                        // setShowTable(true)
                    }
                    setShowTable(true)
                    // setBmiRptList(bmiResult.data)
                }
            })
    }

    function exportnow() {
        const formData = new FormData();
        formData.append('institutionType', groupId);
        formData.append('institutionId', institutionId);
        formData.append('batchId', batchId);
        const exprt = api.ExportBMIReport;
        fetch(exprt, {
            method: "POST",
            headers: {
                "Authorization": 'Bearer ' + Utils.getAccessToken()
            },
            body: formData,
        })
            .then((exportReponse) => exportReponse.json())
            .then((exportResult) => {
                if (exportResult.error == true) {
                    if (exportResult.code == 401) {
                        Utils.logoutUser();
                    }
                } else {
                    const blob = new Blob([exportResult.data], { type: "application/vnd.ms-excel" });
                    const url = URL.createObjectURL(blob);
                    const a = document.createElement("a");
                    a.href = url;
                    a.download = "BMIReport.xls"; // Save file as .xls
                    document.body.appendChild(a);
                    a.click();
                    document.body.removeChild(a);
                    URL.revokeObjectURL(url);
                }
            })
            .catch((error) => {
                console.log("Failed to export BMI Report", error);
            })
    }

    const filteredData = bmiRptList.filter((datas) => {
        const values = Object.values(datas).map((value) =>
            value !== null && value !== undefined ? value.toString().toLowerCase() : '');
        return values.some((value) => value.includes(searchInput.toLowerCase()));
    });

    const slNoRender = (rowData, column) => {
        return column.rowIndex + 1;
    };

    const studentRender = (rowData) => {
        return <span>{rowData.studentName}</span>
    };

    const ageRender = (rowData) => {
        return <span>{rowData.Age}</span>
    };

    const heightRender = (rowData) => {
        return <span>{rowData.coreUserHeight}</span>
    };

    const weightRender = (rowData) => {
        return <span>{rowData.coreUserWeight}</span>
    };

    const bmiRender = (rowData) => {
        return <span>{rowData.BMI}</span>
    };

    const descriptionRender = (rowData) => {
        return <span>{rowData.bmiDefination}</span>
    };

    return (
        <>
            <div className="content container">
                <div className="row">
                    <div className="sortby-section">
                        <div className="sorting-info">
                            <div className="row d-flex align-items-center">
                                <h3 className="text-center mb-40">
                                    <i className="fa fa-university"></i>
                                    BMI Report
                                </h3>
                            </div>
                            <div>
                                <Link
                                    to={routes.reports}
                                    className="btn btn-primary save-profile"
                                >
                                    <i className="fas fa-arrow-left"></i>Back
                                </Link>
                            </div>
                            <div className="row">
                                <div className="col-md-12">
                                    <div className="court-tab-content">
                                        <div className="court-tab-content">
                                            <div className="card card-tableset">
                                                <div className="card-body">
                                                    <div className="coache-head-blk">
                                                        <div className="row align-items-center">
                                                            <div className="row col-md-12">
                                                                <div className="row col-md-12 court-sortby sortbyset">
                                                                    <div className="col-md-3">
                                                                        <div className="mb-10">
                                                                            <label className="sortbytitle"><h6>Institute Group</h6></label>
                                                                            <Select
                                                                                value={groupList.find(grp => grp.institutionGroupId === groupId) ? {
                                                                                    value: groupId,
                                                                                    label: groupList.find(grp => grp.institutionGroupId === groupId).institutionGroupName
                                                                                } : null}
                                                                                onChange={(e) => {
                                                                                    setGroupId(e.value);
                                                                                    getInstitutes(e.value)
                                                                                }}
                                                                                options={groupList.map(grp => ({
                                                                                    value: grp.institutionGroupId,
                                                                                    label: grp.institutionGroupName
                                                                                }))}>
                                                                            </Select>
                                                                        </div>
                                                                    </div>
                                                                    <div className="col-md-3">
                                                                        <div className="mb-10">
                                                                            <label className="sortbytitle"><h6>Institute</h6></label>
                                                                            <Select value={instituteList.find(inst => inst.institutionId === institutionId) ? {
                                                                                value: institutionId,
                                                                                label: instituteList.find(inst => inst.institutionId === institutionId).institutionName
                                                                            } : null}
                                                                                onChange={(e) => {
                                                                                    setInstitutionId(e.value)
                                                                                    getBatchList(e.value)
                                                                                }}
                                                                                options={instituteList.map(inst => ({
                                                                                    value: inst.institutionId,
                                                                                    label: inst.institutionName
                                                                                }))}
                                                                                placeholder={"Select Institute"}
                                                                            />
                                                                        </div>
                                                                    </div>
                                                                    <div className="col-md-3">
                                                                        <div className="mb-10">
                                                                            <label className="sortbytitle"><h6>Batch</h6></label>
                                                                            <Select value={batchList.find(btch => btch.batchId === batchId) ? {
                                                                                value: batchId,
                                                                                label: batchList.find(btch => btch.batchId === batchId).batchName
                                                                            } : null}
                                                                                onChange={(e) => {
                                                                                    setBatchId(e.value)
                                                                                }}
                                                                                options={batchList.map(btch => ({
                                                                                    value: btch.batchId,
                                                                                    label: btch.batchName
                                                                                }))}
                                                                                placeholder={"Select Batch"}
                                                                            />
                                                                        </div>
                                                                    </div>
                                                                    <div className="col-md-3">
                                                                        <div className="save-changes text-sm mt-4">
                                                                            <Button onClick={getReport}>Submit</Button>
                                                                            <Button onClick={exportnow}>Export</Button>
                                                                        </div>
                                                                    </div>
                                                                    <div className="col-md-12 border-bottom" style={{ marginTop: "1rem", marginBottom: "1rem" }} />
                                                                    {showTable && (
                                                                        <>
                                                                            <div className="col-md-12">
                                                                            </div>
                                                                            <div className="col-md-12">
                                                                            </div>
                                                                            <div className="col-md-6">
                                                                            </div>
                                                                            <div className="col-md-6">
                                                                                <div className="dataTables_filter">
                                                                                    <label>
                                                                                        <input
                                                                                            type="text"
                                                                                            value={searchInput}
                                                                                            onChange={(e) => setSearchInput(e.target.value)}
                                                                                            placeholder="Search"
                                                                                            className="form-control"
                                                                                        />
                                                                                    </label>
                                                                                </div>
                                                                            </div>
                                                                        </>
                                                                    )}
                                                                </div>
                                                            </div>
                                                            {showTable && (
                                                                <>
                                                                    <div className="tab-content mt-2">
                                                                        <div
                                                                            className="tab-pane fade show active"
                                                                            id="nav-Recent"
                                                                            role="tabpanel"
                                                                            aria-labelledby="nav-Recent-tab"
                                                                            tabIndex={0}
                                                                        >
                                                                            <div className="table-responsive table-datatble">
                                                                                <DataTable
                                                                                    className="table datatable"
                                                                                    value={filteredData}
                                                                                    paginator
                                                                                    rows={10}
                                                                                    rowsPerPageOptions={[10, 25, 50, 100]}
                                                                                    // currentPageReportTemplate="{first}- {last} of {totalRecords} entries"
                                                                                    pageLinkSize={3}
                                                                                >
                                                                                    <Column
                                                                                        sortable
                                                                                        headerClassName="text-uppercase"
                                                                                        field="slNo"
                                                                                        body={slNoRender}
                                                                                        header="Sl No"
                                                                                    ></Column>
                                                                                    <Column
                                                                                        sortable
                                                                                        headerClassName="text-uppercase"
                                                                                        field="studentName"
                                                                                        body={studentRender}
                                                                                        header="Student Name"
                                                                                    ></Column>
                                                                                    <Column
                                                                                        sortable
                                                                                        headerClassName="text-uppercase"
                                                                                        field="Age"
                                                                                        body={ageRender}
                                                                                        header="Age"
                                                                                    ></Column>
                                                                                    <Column
                                                                                        sortable
                                                                                        headerClassName="text-uppercase"
                                                                                        field="coreUserHeight"
                                                                                        body={heightRender}
                                                                                        header="Height"
                                                                                    ></Column>
                                                                                    <Column
                                                                                        sortable
                                                                                        headerClassName="text-uppercase"
                                                                                        field="coreUserWeight"
                                                                                        body={weightRender}
                                                                                        header="Weight"
                                                                                    ></Column>
                                                                                    <Column
                                                                                        sortable
                                                                                        headerClassName="text-uppercase"
                                                                                        field="BMI"
                                                                                        body={bmiRender}
                                                                                        header="BMI"
                                                                                    ></Column>
                                                                                    <Column
                                                                                        sortable
                                                                                        headerClassName="text-uppercase"
                                                                                        field="bmiDefination"
                                                                                        body={descriptionRender}
                                                                                        header="Description"
                                                                                    ></Column>
                                                                                </DataTable>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </>
                                                            )}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div >
            </div >
        </>
    );
};

export default bmiReport;